<template>
  <Row v-if="model">
    <div class="subject-item">
      <Icon :type="'ios-' + icon" :style="'color:' + color"/>
         {{ model.subjid }} / {{ model.name }} / {{ model.siteName }}
      <span class="edit-btn" @click="showEdit = true">编辑</span>
    </div>
    <Modal v-model="showEdit" title="编辑受试者" :footer-hide="true">
        <edit-subject ref="editSubject" :model="model" @refresh="refresh"></edit-subject>
    </Modal>
  </Row>
</template>
<script>
import EditSubject from './EditSubject'
import moment from 'moment'

export default {
  name: 'subject-info',
  data: function () {
    return {
      showEdit: false,
      sts: {
        '1': {
          color: '#2d8cf0',
          icon: 'funnel'
        },
        '2': {
          color: '#ff2600',
          icon: 'remove-circle'
        },
        '3': {
          color: '#0fa78c',
          icon: 'flag'
        },
        '4': {
          color: '#a14e26',
          icon: 'pause'
        },
        '5': {
          color: '#19be6b',
          icon: 'checkmark-circle'
        }
      }
    }
  },
  components: {
    'edit-subject': EditSubject
  },
  computed: {
    icon: function () {
      return this.sts[this.model.status].icon
    },
    color: function () {
      return this.sts[this.model.status].color
    },
    regdate: function () {
      return moment(this.model.regdate).format('YYYY-MM-DD')
    }
  },
  props: ['model'],
  methods: {
    refresh: function () {
      this.$emit('refresh')
      this.showEdit = false
    }
  }
}
</script>
<style scoped>
.subject-item {
  padding: 8px 20px;
  margin-bottom: 10px;
  font-size: 1.2em;
  font-weight: bolder;
  background-color: #FFFFFF;
}
.subject-item > .edit-btn {
  float: right;
  position: relative;
}
</style>
